import { styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  scanHistoryAgGridStyle: 'scanHistoryAgGridStyle',
  scanChartMainBox: 'scanChartMainBox',
  Table_Chart_Button_Box: 'Table_Chart_Button_Box',
  Table_Chart_Button_Inner_wrapped_Box: 'Table_Chart_Button_Inner_wrapped_Box',
  Table_Chart_Button: 'Table_Chart_Button',
  documentRowTypographyColor: 'documentRowTypographyColor',
  scanHistoryGridBox: 'scanHistoryGridBox',
  scanHistoryChartBox: 'scanHistoryChartBox',
  scanHistoryChart: 'scanHistoryChart',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.scanHistoryAgGridStyle}`]: {
    [up('xs')]: {
      height: '44vh',
    },
    [up('sm')]: {
      height: '53vh',
    },
    [up('md')]: {
      height: '52vh',
    },
    [up('lg')]: {
      height: '57vh',
    },
    [up('xl')]: {
      height: '68vh',
    },
    [up('xxl')]: {
      height: '71vh',
    },
  },
  [`& .${classes.scanChartMainBox}`]: {
    width: '100%',
    backgroundColor: theme.palette.lunarBase.lightest,
    [up('xs')]: {
      height: '37vh',
    },
    [up('sm')]: {
      height: '52vh',
    },
    [up('md')]: {
      height: '50vh',
    },
    [up('lg')]: {
      height: '55vh',
    },
    [up('xl')]: {
      height: '67vh',
    },
    [up('xxl')]: {
      height: '67vh',
    },
  },
  [`& .${classes.Table_Chart_Button_Box}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.scanHistoryChartBox}`]: {
    position: 'relative',
    [up('xs')]: {
      minWidth: '530px',
    },
    [up('sm')]: {
      minWidth: '130px',
      height: '270px',
    },
    [up('md')]: {
      minWidth: '590px',
      height: '265px',
    },
    [up('lg')]: {
      minWidth: '1020px',
      height: '320px',
    },
    [up('xl')]: {
      minWidth: '1350px',
      height: '550px',
    },
    [up('xxl')]: {
      minWidth: '1550px',
      height: '650px',
    },
  },
  [`& .${classes.scanHistoryGridBox}`]: {
    marginTop: theme.spacing(1),
  },
  [`& .${classes.Table_Chart_Button_Inner_wrapped_Box}`]: {
    border: `1px solid ${theme.palette.darkPurple.lightest}`,
    borderRadius: '5px',
  },
  [`& .${classes.Table_Chart_Button}`]: {
    margin: theme.spacing(0.5),
    [up('xs')]: {
      width: '70px',
      height: '23px',
    },
    [up('sm')]: {
      width: '87px',
      height: '27px',
    },
    [up('md')]: {
      width: '83px',
      height: '25px',
    },
    [up('lg')]: {
      width: '90px',
      height: '30px',
    },
    [up('xl')]: {
      width: '95px',
      height: '33px',
    },
    [up('xxl')]: {
      width: '103px',
      height: '35px',
    },
  },
  [`& .${classes.documentRowTypographyColor}`]: {
    color: theme.palette.lunarBase.main,
  },
  [`& .${classes.scanHistoryChart}`]: {
    height: '100%',
    width: '100%',
    marginLeft: '3vw',
    paddingTop: '3vh',
  },
}));
